import React from "react";
import CommonNavbar from "../components/CommonNavbar/CommonNavbar";
import Faq from "../components/Policy/Faq";
import CommonFooter from "../components/CommonFooter/CommonFooter";

const FaqPage = () => {
  return (
    <div>
      <CommonNavbar hide_btn="d-none" show_btn="d-block" />
      <Faq />
      <CommonFooter />
    </div>
  );
};

export default FaqPage;
